<style lang="scss" >
@import "resources/sass/v1/abstracts/_variables";

.language {
    position: relative;
    z-index: 2;
    background-color: #ecf5f9;
    padding: 16px 72px 16px 48px;
    display: block;
    font-family: $headings-font-family;
    cursor: pointer;

    &:after {
        content: "";
        background-image: url("/svg/icons/icon-chevron-down.svg");
        background-position: center;
        background-repeat: no-repeat;
        width: 10px;
        height: 6px;
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s;
    }

    &:hover {
        &:after {
            transform: rotate(-180deg) translateY(calc(-50% + 6px));
        }

        .dropdown {
            display: block;
        }
    }

    span {
        color: #484848;
        font-size: 14px;
        font-weight: $font-weight-bold;
        position: relative;
        text-transform: none;

        &:before {
            left: -33px;
            top: -1px;
        }
    }

    span,
    li {
        &:before {
            position: absolute;
            width: 20px;
            height: 20px;
        }

        &.nl {
            &:before {
                content: url("/svg/flags/netherlands.svg");
            }
        }

        &.fr {
            &:before {
                content: url("/svg/flags/france.svg");
            }
        }
    }

    .dropdown {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;

        ul {
            position: relative;
            display: block;
            cursor: pointer;
            padding: 0;
            margin: 0;

            li {
                list-style-type: none;
                position: relative;
                text-transform: none;
                border-top: 1px solid rgba(4, 4, 4, 0.04);
                background-color: #ecf5f9;
                transition: background-color 0.2s;

                a {
                    display: block;
                    font-family: $headings-font-family;
                    padding: 16px 72px 16px 48px;
                    width: 100%;
                    color: #484848 !important;
                    line-height: 1.5;
                    font-size: 14px;
                    font-weight: $font-weight-bold;
                }

                &:before {
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                }

                &:hover {
                    background-color: #e6eaee;
                }
            }
        }
    }
}
</style>

<template>
    <div class="language">
        <span :class="locale">{{ languages[locale] }}</span>

        <div class="dropdown w-100" id="dropdown-menu">
            <ul>
                <li v-for="otherLocale in localesExcludingCurrent" :key="otherLocale" :class="otherLocale"><a :href="translatedUrl(otherLocale)">{{ languages[otherLocale] }}</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        locale: {
            type: String,
            required: true
        },
        languages: {
            type: Object,
            required: true
        },
        currentRoute: {
            type: String,
            required: true
        },
        slug: {
            type: [Array, String],
            required: true
        },
        id: {
            type: Number,
            default: null,
        }
    },

    computed: {
        localesExcludingCurrent() {
            var keys = Object.keys(this.languages);
            keys = keys.filter(e => e !== this.locale);
            return keys;
        },
        parameters() {
            const params = { slug: this.slug }
            if (this.id) {
                params.id = this.id
            }
            return params
        }
    },

    methods: {
        translatedUrl(locale) {
            if (this.currentRoute.indexOf('landing') >= 0) {
                return `/${locale}/${this.slug}`;
            } else {
                return (this.slug == [] ? route(this.currentRoute.replace(this.locale, locale)) : route(this.currentRoute.replace(this.locale, locale), this.parameters));
            }
        }
    }
}
</script>